import $ from 'jquery';
import {Dialog} from "../Libraries/Dialog";
//import {preventWrap, wait, nextFrame} from "../Libraries/Utils";

const $searchPopup = $('#search-popup');

$(document).on('click', 'a[href="#search"]', ev => {
    ev.preventDefault();

    const dialog = new Dialog({
        type: 'inline',
        addModifier: 'search',
        items: [{
            src: $searchPopup,
        }]
    });

    dialog.open();

});
